import React from 'react';
const AppliedFilter = (props) =>{
  return(
    <ul {...props}>
      {props.children}
    </ul>
  )
}
export default AppliedFilter;
